import {useRouter} from 'next/router';
import {MouseEvent, useCallback} from 'react';
import {aggregateAndSendLog} from '../../logging/aggregateAndSendLog';
import {LOG_CLICK_EVENT} from '../../logging/logEvent';
import {putTiaraObjectProps} from '../../logging/putTiaraObjectProps';
import {useSinglePreviewQuery} from '../../wrapper';
import {PcViewerCommentHeader} from '../organisms/PcViewerCommentHeader/PcViewerCommentHeader';

export function PcLayoutViewerCommentHeader() {
  const router = useRouter();
  const productId = Number(router.query.productId);

  const onClickBack = useCallback(
    (e: MouseEvent) => {
      LOG_CLICK_EVENT('뒤로가기', e, () => router.back());
    },
    [router]
  );

  const onClickContentsHomeButton = useCallback(
    (e: MouseEvent) => {
      aggregateAndSendLog({
        targetElem: e.target as HTMLElement,
        eventMeta: {
          id: String(router.query.seriesId),
          type: 'seriesId',
          series_id: String(router.query.seriesId),
        },
        actionType: 'Event',
        actionName: '작품홈_클릭',
        customProps: {
          user_action: 'click',
        },
      });
    },
    [router]
  );

  const singlePreviewResult = useSinglePreviewQuery({productId});
  const {data: singlePreviewData} = singlePreviewResult;

  const productTitle = singlePreviewData?.singlePreview?.title;

  return (
    <div
      className="w-1200pxr"
      {...putTiaraObjectProps({
        ...(router.query.productId
          ? {
              customProps: {event_episode_id: String(router.query.productId)},
            }
          : undefined),
      })}
    >
      <PcViewerCommentHeader
        title={productTitle}
        seriesId={Number(router.query.seriesId)}
        onClickBack={onClickBack}
        onClickContentHome={onClickContentsHomeButton}
      />
    </div>
  );
}
